import CategoryFilters from '@/components/app/archive/components/filter/@shared/items/category-filters';
import MedalFilters from '@/components/app/archive/components/filter/@shared/items/medal-filters';
import Props from '@/components/app/archive/components/filter/@shared/items/type';
import ViewSelector from '@/components/app/archive/components/filter/@shared/items/view-selector';
import Separator from '@/components/app/archive/components/separator';

export default function FilterItems({ initialFilters }: Props) {
  return (
    <>
      <CategoryFilters initialFilters={initialFilters} />
      <Separator className='my-5' />
      <ViewSelector initialFilters={initialFilters} />
      <Separator className='my-5' />
      <MedalFilters initialFilters={initialFilters} />
    </>
  );
}
